/** Sidebar, login page, session banners, shared page furniture. */
const shell = {
  'Submit and review coverage requests for your distributor customers.':
    'Env\u00ede y revise las solicitudes de cobertura de los clientes de su distribuidor.',
  'Submit a coverage request for one of your distributor customers.':
    'Env\u00ede una solicitud de cobertura para uno de los clientes de su distribuidor.',
  'Add a customer before submitting an IVR.': 'Agregue un cliente antes de enviar un IVR.',
  'Continue to IVR': 'Continuar al IVR',
  'The IVR result could not be confirmed. Check the IVR list or retry this unchanged request.':
    'No se pudo confirmar el resultado del IVR. Consulte la lista de IVR o vuelva a intentar esta misma solicitud sin cambios.',
  'This distributor customer is unavailable. Close this form and refresh Customers before trying again.':
    'Este cliente del distribuidor no est\u00e1 disponible. Cierre este formulario y actualice Clientes antes de intentarlo de nuevo.',
  // Navigation groups and items (data/navigation.js)
  Work: 'Trabajo',
  MedEffects: 'MedEffects',
  'Workspace navigation': 'Navegaci\u00f3n del espacio de trabajo',
  'Distributor Navigation': 'Navegaci\u00f3n de distribuidores',
  'Tissue Bank': 'Banco de tejidos',
  Setup: 'Configuraci\u00f3n',
  Operations: 'Operaciones',
  Business: 'Negocio',
  'Tools & support': 'Herramientas y soporte',
  Distributor: 'Distribuidor',
  'Distributor bank': 'Banco del distribuidor',
  'Distributor setup': 'Configuración de distribuidores',
  'Distributor clinics': 'Clínicas del distribuidor',
  'Distributor overview': 'Resumen del distribuidor',
  Overview: 'Resumen',
  'Refresh overview': 'Actualizar resumen',
  'Overview is unavailable. Please try again.':
    'El resumen no está disponible. Inténtelo de nuevo.',
  'Loading overview...': 'Cargando resumen...',
  'Open orders': 'Pedidos abiertos',
  'IVRs needing review': 'IVR que necesitan revisión',
  'Open shipments': 'Envíos abiertos',
  'Create clinic': 'Crear cl\u00ednica',
  Street: 'Calle',
  'Your distributor customers': 'Sus clientes del distribuidor',
  'Add a distributor customer here. This customer list is separate from your MedEffects client clinics and shared by your distributor portal users.':
    'Agregue aquí un cliente del distribuidor. Esta lista es independiente de sus clínicas de MedEffects y se comparte entre los usuarios del portal de su distribuidor.',
  'No distributor customers yet. Create a clinic above to get started.':
    'Aún no hay clientes del distribuidor. Cree una clínica arriba para comenzar.',
  'Your associated clinics': 'Sus clínicas asociadas',
  'Your clinics follow your MedEffects client account. Newly assigned clinics appear with ordering disabled until their settings are reviewed.':
    'Sus clínicas siguen su cuenta de cliente de MedEffects. Las clínicas recién asignadas aparecen con los pedidos desactivados hasta que se revisen sus ajustes.',
  '{count} clinics': '{count} clínicas',
  '{count} clinic': '{count} clínica',
  'Clinic detail': 'Detalle de la clínica',
  'Loading clinics...': 'Cargando clínicas...',
  'Could not load your clinics. Please try again.':
    'No se pudieron cargar sus clínicas. Inténtelo de nuevo.',
  'No clinics are associated with your distributor account yet.':
    'Aún no hay clínicas asociadas a su cuenta de distribuidor.',
  'Could not open this clinic. Please try again.':
    'No se pudo abrir esta clínica. Inténtelo de nuevo.',
  Billing: 'Facturación',
  Records: 'Registros',
  System: 'Sistema',
  Dashboard: 'Panel',
  Orders: 'Pedidos',
  'IVR Details': 'Detalles de IVR',
  Shipments: 'Envíos',
  Invoices: 'Facturas',
  Statements: 'Estados de cuenta',
  Reports: 'Informes',
  'Sales Reps': 'Representantes de ventas',
  'My Team': 'Mi equipo',
  Clinics: 'Clínicas',
  Providers: 'Proveedores',
  Products: 'Productos',
  Users: 'Usuarios',
  Integrations: 'Integraciones',
  'Audit Logs': 'Registros de auditoría',
  Settings: 'Configuración',
  Logout: 'Cerrar sesión',

  // Language toggle
  'Change language': 'Cambiar idioma',
  'View in Spanish': 'Ver en español',
  'View in English': 'Ver en inglés',

  // Login page
  'MedEffects Portal': 'Portal de MedEffects',
  'Distributor Portal': 'Portal de distribuidores',
  'Distributor sign in': 'Iniciar sesión como distribuidor',
  'A clearer way to work': 'Una forma más clara de trabajar',
  'Your clinics and product bank, in one place.':
    'Sus clínicas y banco de productos, en un solo lugar.',
  'Manage clinics, review your bank, and follow order activity from one workspace.':
    'Administre clínicas, consulte su banco y siga la actividad de pedidos desde un solo lugar.',
  'Use your distributor username and password.':
    'Use su nombre de usuario y contraseña de distribuidor.',
  'Product bank': 'Banco de productos',
  Shipping: 'Envío',
  'Orders use available product-family units from your bank.':
    'Los pedidos usan las unidades disponibles por familia de productos en su banco.',
  'Search clinics': 'Buscar clínicas',
  'Select size': 'Seleccionar tamaño',
  'No clinics match your search.': 'Ninguna clínica coincide con su búsqueda.',
  'MedEffects client sign in': 'Iniciar sesión en MedEffects',
  Username: 'Nombre de usuario',
  'Enter your username': 'Ingrese su nombre de usuario',
  'Username and password are required': 'El nombre de usuario y la contraseña son obligatorios',
  'Invalid username or password': 'Nombre de usuario o contraseña no válidos',
  'Access denied. This portal is for distributor accounts.':
    'Acceso denegado. Este portal es para cuentas de distribuidores.',
  'Sign in to continue': 'Inicie sesión para continuar',
  Email: 'Correo electrónico',
  Password: 'Contraseña',
  'Enter your email': 'Ingrese su correo electrónico',
  'Enter your password': 'Ingrese su contraseña',
  'Show password': 'Mostrar contraseña',
  'Hide password': 'Ocultar contraseña',
  'Signing in...': 'Iniciando sesión...',
  'Sign In': 'Iniciar sesión',
  'Email and password are required': 'El correo electrónico y la contraseña son obligatorios',
  'Login failed': 'No se pudo iniciar sesión',
  'Too many sign-in attempts. Please wait a minute and try again.':
    'Demasiados intentos de inicio de sesión. Espere un minuto e inténtelo de nuevo.',
  'Access denied. This portal is for MedEffects staff and clinic accounts.':
    'Acceso denegado. Este portal es para el personal de MedEffects y las cuentas de clínicas.',
  // The server's own sign-in sentences (auth.service.ts), so a wrong password reads in Spanish too.
  'Invalid email or password': 'Correo electrónico o contraseña no válidos',
  'Invalid credentials': 'Credenciales no válidas',
  'Account is temporarily locked. Please try again later.':
    'La cuenta está bloqueada temporalmente. Inténtelo de nuevo más tarde.',
  'Account is deactivated': 'La cuenta está desactivada',
  'Network Error': 'Error de red',

  // Session-ended banners (utils/sessionEnded.js)
  'You were signed out after 30 minutes of inactivity. Please sign in again.':
    'Se cerró su sesión tras 30 minutos de inactividad. Inicie sesión de nuevo.',
  'Your session ended. Please sign in again.': 'Su sesión finalizó. Inicie sesión de nuevo.',
  'Your password was changed. Please sign in again with your new password.':
    'Su contraseña se cambió. Inicie sesión de nuevo con su nueva contraseña.',
  'Your password change could not be confirmed. Please sign in again.':
    'No se pudo confirmar el cambio de contraseña. Inicie sesión de nuevo.',

  // Error boundary
  'Something went wrong. Reload the page.': 'Algo salió mal. Recargue la página.',
  'If it keeps happening, sign out and sign back in.':
    'Si sigue ocurriendo, cierre sesión y vuelva a iniciarla.',
  Reload: 'Recargar',
  'Low-bank alerts': 'Alertas de saldo bajo',
  'Choose how this account is notified when a product family first falls to 100 units or fewer.':
    'Elija cómo se notificará a esta cuenta cuando una familia de productos baje por primera vez a 100 unidades o menos.',
  'Bank alerts are unavailable. Please try again.':
    'Las alertas del banco no están disponibles. Inténtelo de nuevo.',
  'Preferences could not be confirmed. Reload and try again.':
    'No se pudieron confirmar las preferencias. Recargue e inténtelo de nuevo.',
  'Bank alert preferences saved.': 'Se guardaron las preferencias de alertas.',
  'Loading bank alerts...': 'Cargando alertas del banco...',
  'No low-bank alerts yet.': 'Todavía no hay alertas de saldo bajo.',
  'In-app': 'En la aplicación',
  'Save alert preferences': 'Guardar preferencias de alertas',
  'units remaining': 'unidades restantes',
};

export default shell;
